module.exports = __webpack_public_path__ + "static/media/empty-favorites-placeholder.b358518d.svg";